import http from '@/utils/http'

import {
  ToolsManageParams,
  ToolsManageListItem,
  NotifyListPageParams,
  NotifyListGetResult,
} from './model'

export * from './model'

enum Source {
  // 工具列表
  TOOL_LIST = '/base/web/tool-manage/list',
  // 通知分页列表
  NOTIFICATION_LIST = '/base/web/system-message/list',
  // 消息标记未已读
  SET_READ = '/base/web/system-message/set-read',
  // 查询已-未读数量
  QUERY_READ_COUNT = '/base/web/system-message/query-read-count',
  // 全部设置已读
  SET_ALL_READ = '/base/web/system-message/set-all-read',
  // 全部设置已读
  SHOWLIST = '/base/web/system-message/showlist',
}

/**
 * 工具查询
 * @param data 查询参数
 */
export const toolListApi = (data: ToolsManageParams) =>
  http.post<ToolsManageListItem[]>({ url: Source.TOOL_LIST, data })

/**
 * 通知查询
 * @param data 查询参数
 */
export const notificationListApi = (data: NotifyListPageParams) =>
  http.post<NotifyListGetResult>({ url: Source.NOTIFICATION_LIST, data })

/**
 * 消息标记未已读
 * @param data 查询参数
 */
export const setReadApi = (data: { msgIdList: number[] }) =>
  http.post<void>({ url: Source.SET_READ, data })

/**
 * 查询已-未读数量
 */
export const queryReadCountApi = (data: Pick<NotifyListPageParams, 'yesRead' | 'msgMode'>) =>
  http.post<number>({ url: Source.QUERY_READ_COUNT, data })

/**
 * 全部设置已读
 */
export const setAllReadApi = (data: { msgMode: number }) =>
  http.post<void>({ url: Source.SET_ALL_READ, data })

/**
 * 弹窗消息
 */
export const showlistApi = (data: { msgMode: number }) =>
  http.post<NotifyListGetResult['records']>({ url: Source.SHOWLIST, data })
